export const NNormalBoxSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="25" fill="none" viewBox="0 0 23 25" {...props}>
  <g clipPath="url(#a)">
    <path fill="#000" d="M11.337 25 0 19.477V5.523L11.337 0l11.337 5.523v13.954L11.337 25Zm-1.102-2.931V12.016l-8.03-3.937v10.053l8.018 3.925.012.012Zm1.102-11.895 3.319-1.623-8.018-3.924-3.32 1.623 8.02 3.924Zm4.712-2.3 3.319-1.624-8.019-3.924-3.318 1.623 8.018 3.924Zm-3.61 14.183 8.019-3.925V8.08l-8.019 3.924v10.054Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#fff" d="M0 0h22.674v25H0z"/>
    </clipPath>
  </defs>
</svg>
);
